export default "__VITE_ASSET__C_yNC$tx__"